import styled from "styled-components";

const FormWrapper = styled.form`
  width: stretch;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 12px;

  button[type="submit"] {
    margin-top: 24px;
  }

  .spanFull {
    grid-column: 1/3;
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;

    .spanFull {
      grid-column: unset;
    }
  }
`;

export default FormWrapper;
